import { createSlice } from "@reduxjs/toolkit";

export const messageSlice = createSlice({
  name: "user",
  initialState: { value: { message: "", isSuccess: false } },
  reducers: {
    sendMessage: (state, { payload }) => {
        console.log('dsfsafdsa', payload)
      state.value = {message: 'testing', isSuccess: true};
    },
    removeMessage: (state) => {
      state.value = { message: "", isSuccess: false };
    },
  },
});

export const { sendMessage, removeMessage } = messageSlice.actions;
export default messageSlice.reducer;
